import { render } from "./ClassDetailsTable.vue?vue&type=template&id=3b8c2636&scoped=true&ts=true"
import script from "./ClassDetailsTable.vue?vue&type=script&lang=ts"
export * from "./ClassDetailsTable.vue?vue&type=script&lang=ts"

import "./ClassDetailsTable.vue?vue&type=style&index=0&id=3b8c2636&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8c2636"]])

export default __exports__